module.exports = __webpack_public_path__ + "img/save_to_gpay.db86b27b.svg";